import React from "react";

const SuspenseFallback: React.FC = () => {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "100vh",
        width: "100%",
        backgroundColor: "#FAFBFB",
      }}>
      <div
        style={{
          width: 40,
          height: 40,
          border: "3px solid #EEF2F6",
          borderTopColor: "#2233EA",
          borderRadius: "50%",
          animation: "cwv-spin 0.8s linear infinite",
        }}
      />
      <style>{`@keyframes cwv-spin { to { transform: rotate(360deg) } }`}</style>
    </div>
  );
};

export default SuspenseFallback;
